import {
  ADD_STUDENT_ROUTE,
  CARD_CONTRACT_ROUTE,
  CARD_QUOTA_ROUTE,
  CARD_NETWORK_ROUTE,
  HOME_ROUTE,
  LOGIN_ROUTE,
  START_ROUTE,
  ACCOUNT_ROUTE, LOAD_ROUTE, AGENT_LIST, EMAIL_LIST, STATS,
  JOURNAL_GROUPS, JOURNAL_GROUP_ROUTE, JOURNAL_SHEET_ROUTE, JOURNAL_WORKLOAD
} from "./utils/consts/pathRoutes";
import HomePage from './Pages/HomePage'
import StartPage from './Pages/StartPage';
import LoginPage from "./Pages/LoginPage";
import PersonalCardContract from "./Pages/PersonalCardContract";
import PersonalCardQuota from "./Pages/PersonalCardQuota";
import AddStudent from "./Pages/AddStudent";
import Index from "./Pages/Account";
import LoadingPage from "./Pages/LoadingPage";
import { AgentPage } from './Pages/Agents';
import { EmailsPage } from './Pages/Emails';
import { StatsPage } from './Pages/Stats/StatsPage';
import GroupsPage from './Pages/Journal/GroupsPage';
import GroupPage from './Pages/Journal/GroupPage';
import SheetPage from './Pages/Journal/SheetPage';
import WorkloadPage from './Pages/Journal/WorkloadPage';

export const readerRoutes = [
    {
        path: HOME_ROUTE,
        Component: HomePage
    },
    {
        path: CARD_CONTRACT_ROUTE,
        Component: PersonalCardContract
    },
    {
        path: CARD_QUOTA_ROUTE,
        Component: PersonalCardQuota
    },
    {
        // У сетевых программ те же поля, что у контракта, поэтому и карточка общая.
        path: CARD_NETWORK_ROUTE,
        Component: PersonalCardContract
    },
    {
        path: ACCOUNT_ROUTE,
        Component: Index
    },
    {
        path: AGENT_LIST,
        Component: AgentPage
    },
    {
        path: EMAIL_LIST,
        Component: EmailsPage
    },
    {
        path: STATS,
        Component: StatsPage
    }
]

export const publicRoutes = [
    {
        path: START_ROUTE,
        Component: StartPage
    },
    {
        path: LOGIN_ROUTE,
        Component: LoginPage
    },
    {
        path: LOAD_ROUTE,
        Component: LoadingPage
    }
]

export const editorRoutes = [
    {
        path: ADD_STUDENT_ROUTE,
        Component: AddStudent
    }
]

export const teacherRoutes = [
    {
        path: HOME_ROUTE,
        Component: HomePage
    }
]

// Электронный журнал. Доступен и роли «Преподаватель ЭЖ», у которой нет доступа
// к контингенту: сервер дополнительно ограничивает её только своими группами.
export const journalRoutes = [
    {
        // Личный кабинет нужен и преподавателю журнала: смена пароля живёт там.
        path: ACCOUNT_ROUTE,
        Component: Index
    },
    {
        path: JOURNAL_GROUPS,
        Component: GroupsPage
    },
    {
        path: JOURNAL_GROUP_ROUTE,
        Component: GroupPage
    },
    {
        path: JOURNAL_SHEET_ROUTE,
        Component: SheetPage
    },
    {
        path: JOURNAL_WORKLOAD,
        Component: WorkloadPage
    }
]
